import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const educationService = {
  getAll,
  getAllEducation,
  add,
  update,
  deleteEdu,
};

async function getAll(limit, offset, search_term) {
  const configOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/education/getAll/${limit}/${offset}?search_term=${search_term}`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function getAllEducation() {
  const configOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };
  const response = await fetch(
    `${config.oat_api_url}/manage/education/getAllHigherEducation`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function add(newGender) {
  const configOptions = {
    method: "POST",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    body: JSON.stringify(newGender),
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/education/add`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function update(emp, emp_id) {
  const configOptions = {
    method: "PUT",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    body: JSON.stringify(emp),
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/education/update/${emp_id}`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}

async function deleteEdu(id) {
  const configOptions = {
    method: "DELETE",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };

  const response = await fetch(
    `${config.oat_api_url}/manage/education/delete/${id}`,
    configOptions
  );
  return APIHandler.handleResponse(response);
}
